// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__15EZj","inputDescription":"styles_inputDescription__3juUd"};